import {
  EnvironmentProviders,
  ErrorHandler,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

export const provideSentry = (): (Provider | EnvironmentProviders)[] => {
  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ logErrors: true }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideEnvironmentInitializer(() => () => inject(Sentry.TraceService)),
  ];
};
